module.exports = __webpack_public_path__ + "assets/ee6f076b73bb620c40b05ac00bb64026.mp3";